import React, { Component } from "react";
import Pagination from "../../Components/Pagination";
import Btn from '../../Components/Btn';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import scrollToComponent from "react-scroll-to-component";
import { getStatus } from "../../config";
import { setPerPage, setPage, getRatings } from "../../store/ratings/actions";
//import { shouldUnhighlightTicket } from "../../store/tickets/actions";
import Display from "../../Components/Display";
import { formatDate } from "../../helpers/formatters";
import RatingStars from "../../helpers/RatingStars.jsx";
import { CSVLink, CSVDownload } from "react-csv";

class RatingsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupActive: null
    };
  }

  setPerPage = e => {
    this.props.setPerPage(e.target.value);
  };

  setPage = id => {
    const table = document.querySelector(".rating-table-card");

    scrollToComponent(table, {
      align: "top"
    });

    console.log({ id });

    this.props.setPage(id);
  };
/*
  shouldUnhighlight = CardID => {
    this.props.shouldUnhighlightTicket(CardID);
  };
  shouldHighlight = CardID => {
    if (!this.props.tickets.highlighted_tickets.length) return false;
    return this.props.tickets.highlighted_tickets.includes(CardID);
  };
*/

  render() {
    const tickets = this.props.rating_tickets;
    console.log('Rating Tickets Store:', tickets);
    console.log('Rating Total Pages', this.props.total_pages);

    const Excelheaders = [
      { label: "Trip Date", key: "myTrips[0].TripDateTime" },
      { label: "Departure Station", key: "myTrips[0].TripOfficeFrom" },
      { label: "Arrival Station", key: "myTrips[0].TripOfficeTo" },
      { label: "Bus Rating", key: "rating.bus.cleanliness"},
      { label: "Driver Rating", key: "rating.driver.performance"},
      { label: "Email", key: "UserEmail"},
      { label: "Mobile Number", key: "phone"}
    ];
    
    return (
      <div className="rating-table-card">
        <div className="header-div">
          <Pagination
            currentPage={this.props.current_page}
            totalPages={this.props.total_pages}
            selectPage={this.props.setPage}
          />
          
          <CSVLink
            className="btn simple small export-btn"
            data={tickets}
            headers={Excelheaders}
            filename={"ratings.csv"}
          >
            Export
          </CSVLink>
          {/*<CSVDownload
            className="btn simple small export-btn"
            data={data}
            headers={headers}
          >
            Down Export
          </CSVDownload>*/}
          
          <Display
            label="Display"
            onChange={this.setPerPage}
            options={[100, 200, 300]}
          />
        </div>
       
        <div className="table-responsive">
          <table className="basic-table align-left">
            <thead>
              <tr>
                {this.props.debug && <th>ID</th>}
                <th>Booking ID.</th>
                <th>Trip ID.</th>
                <th>Trip Date</th>
                <th>Route</th>
                <th>Bus Rating</th>
                <th>Driver Rating</th>
                <th>Email</th>
                <th>Mobile Number</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {tickets.map((ticket, i) => (
                <TicketRow
                  key={ticket.CardID}
                  ticket={ticket}/*
                  shouldUnhighlight={this.shouldUnhighlight}
                  shouldHighlight={this.shouldHighlight}
                  togglePopupClasses={this.togglePopupClasses}*/
                  debug={this.props.debug}
                  i={i}
                />
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          currentPage={this.props.current_page}
          totalPages={this.props.total_pages}
          selectPage={this.props.setPage}
          updatedPage={this.props.current_page - 1}
        />
      </div>
    );
  }
}

class TicketRow extends Component {
  render() {
    const {
      ticket,
      debug,
      i
    } = this.props;

    return (
      <tr
        key={ticket.CardID}
        className= {"bgc__fade"/*
          shouldHighlight(String(ticket.CardID))
            ? "bgc__fade highlight"
            : "bgc__fade"
        */}
      >
        {debug && <td>{i + 1}</td>}
        <td>
          {ticket.CardID}
          <br />
          <span className={`booking-status ${getStatus(ticket.CardStatusID)}`}>
            {getStatus(ticket.CardStatusID)}
          </span>
        </td>
        <td>
          {ticket.myTrips[0].TripSubData_Id}
        </td>
        <td>{formatDate(ticket.myTrips[0].TripDateTime)}</td>
        <td>
          {ticket.myTrips[0].TripOfficeFrom} -{" "}
          {ticket.myTrips[0].TripOfficeTo}
        </td>
        <td>
          <RatingStars
              filled = {ticket.rating.bus.cleanliness}
          />
        </td>
        <td>
          <RatingStars
              filled = {ticket.rating.driver.performance}
          />
        </td>
        <td>
          {ticket.email || ticket.UserEmail}
        </td>
        <td>
          {ticket.phone || ticket.UserTelNo}
        </td>
      </tr>
    );
  }
}

const mapStateToProps = state => ({
  rating_tickets: state.ratings.ratingTickets,
  // highlightedTickets: state.tickets.highlighted_tickets,
  current_page: state.ratings.paginationOptions.page,
  total_pages: state.ratings.total_pages,
  loading_search: state.ratings.loading_search,
  debug: state.app.debug
});

const mapDispatchToProps = dispatch => ({
  setPage: bindActionCreators(setPage, dispatch),
  ratings: bindActionCreators(getRatings, dispatch),
  setPerPage: bindActionCreators(setPerPage, dispatch),
  //shouldUnhighlightTicket: bindActionCreators(shouldUnhighlightTicket, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RatingsTable);
